var _rect, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgVerifyCompleteIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 71,
    height: 71,
    viewBox: "0 0 71 71",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.720703,
    y: 0.532227,
    width: 70,
    height: 70,
    rx: 35,
    fill: "#F46940"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M53.7715 21.475C54.6314 22.2394 54.7089 23.5562 53.9445 24.4162L31.7223 49.4162C31.3269 49.8609 30.7602 50.1154 30.1652 50.1154C29.5701 50.1154 29.0034 49.8609 28.6081 49.4162L17.497 36.9162C16.7325 36.0562 16.81 34.7394 17.67 33.975C18.5299 33.2106 19.8467 33.288 20.6112 34.148L30.1652 44.8963L50.8303 21.648C51.5947 20.788 52.9115 20.7106 53.7715 21.475Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVerifyCompleteIcon);
export default __webpack_public_path__ + "static/media/verifyCompleteIcon.27b004fbcc0b3e752342ce507d262e2b.svg";
export { ForwardRef as ReactComponent };